import { IEquipmentInstructionInfo } from 'fitbeat.gymcore';
import { Equipment, EquipmentRequiringInstruction } from 'fitbeat.models';
import React, { ReactElement } from 'react';
import Dumbbells from '../assets/images/dumbbells.svg';
import MiniUltraband from '../assets/images/miniUltraband.svg';
import Pushbells from '../assets/images/pushbells.svg';
import Universalband from '../assets/images/universalband.svg';
import i18n from './i18n';
import { defaultScale } from './scaling';

interface IEquipmentInstructionInfoDisplay {
  image: ReactElement<{ height: number; width: number }>;
}

const svgHeight = defaultScale(30);
const svgWidth= '90%';
export const EquipmentOptionInstruction: {
  [key in EquipmentRequiringInstruction]: IEquipmentInstructionInfoDisplay
} = {
  [Equipment.ShortUltrabands]: {
    image: (
      <MiniUltraband
        height={svgHeight}
        width={svgWidth}
        preserveAspectRatio='none'
      />
    ),
  },
  [Equipment.UniversalBands]: {
    image: (
      <Universalband
        height={svgHeight}
        width={svgWidth}
        preserveAspectRatio='none'
      />
    ),
  },
  [Equipment.Dumbbells]:{
    image: (
      <Dumbbells
        height={svgHeight}
        width={svgWidth}
      />
    ),
  },
  [Equipment.Pushbells]:{
    image: (
      <Pushbells
        height={svgHeight}
        width={svgWidth}
      />
    ),
  },
};
